import { createContext, type Dispatch, type SetStateAction, use } from "react";

export interface AuthContextType {
  isAuthenticated: boolean;
  token: string | null;
  setToken: Dispatch<SetStateAction<string | null>>;
  logout: () => void;
}

export const LOCALSTORAGE_TOKEN_KEY = "token";
const AUTHENTICATED_DOCUMENT_ATTRIBUTE = "data-authenticated";

export const getTokenFromLocalStorage = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_KEY);

  if (token) {
    return token;
  }

  return null;
};

export const applyDocumentAuthenticationState = (isAuthenticated: boolean) => {
  if (typeof document === "undefined") {
    return;
  }

  document.documentElement.setAttribute(AUTHENTICATED_DOCUMENT_ATTRIBUTE, isAuthenticated ? "true" : "false");
};

export const getAuthInitializationScript = () => `(function(){
    try {
        var storageKey = ${JSON.stringify(LOCALSTORAGE_TOKEN_KEY)};
        var hasToken = Boolean(window.localStorage.getItem(storageKey));
        document.documentElement.setAttribute(${JSON.stringify(AUTHENTICATED_DOCUMENT_ATTRIBUTE)}, hasToken ? "true" : "false");
    } catch {
        document.documentElement.setAttribute(${JSON.stringify(AUTHENTICATED_DOCUMENT_ATTRIBUTE)}, "false");
    }
})();`;

export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const useAuth = () => use(AuthContext);
